<template>
    <div v-click-outside="handleFocusOut">
        <b-form-input
            @keyup="search"
            @focus="showSuggestion = true"
            :placeholder="placeholder"
            :disabled="disabled"
            v-model="qs"
            :state="state"
        />
        <div style="position: relative;" v-show="showSuggestion" tabindex="0">
            <div class="position-absolute w-100 zindex-1 cursor-pointer rounded-bottom border-left border-right border-bottom">
                <b-list-group flush>
                    <b-list-group-item v-for="suggestion in suggestions" @click="pick(suggestion)">
                        <span>{{ suggestion.title }}</span>
                    </b-list-group-item>
                </b-list-group>
            </div>
        </div>
    </div>
</template>

<script>
import { BFormInput, BListGroup, BListGroupItem } from 'bootstrap-vue'
import { VueAutosuggest } from 'vue-autosuggest'
import {ProductApi} from "@core/api";

export default {
    components: {
        VueAutosuggest,
        BFormInput,
        BListGroup, BListGroupItem
    },
    directives: {
        'click-outside': {
            bind: function (el, binding, vnode) {
                el.clickOutsideEvent = function (event) {
                    // here I check that click was outside the el and his children
                    if (!(el == event.target || el.contains(event.target))) {
                        // and if it did, call method provided in attribute value
                        vnode.context[binding.expression](event);
                    }
                };
                document.body.addEventListener('click', el.clickOutsideEvent)
            },
            unbind: function (el) {
                document.body.removeEventListener('click', el.clickOutsideEvent)
            },
        }
    },
    props: {
        showSelectedBadge: {
            type: Boolean,
            default: false
        },
        supplier: {
            required: true,
            type: Object,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        state: {
            default: null
        },
        placeholder: {
            type: String,
            default() {
                return this.$t('Component(IncludedProduct):search-placeholder')
            }
        },
        value: {
            default: null
        }
    },
    data() {
        return {
            qs: '',
            showSuggestion: true,
            suggestions: [],
            searchTimer: null,
            inputProps: {
                id: 'autosuggest__input_ajax',
                placeholder: this.placeholder,
                class: 'form-control w-100',
                name: 'ajax',
            },
        };
    },
    methods: {
        getSuggestionValue({item}) {
            return this.value ?? item.title;
        },
        search() {
            if (this.searchTimer) {
                clearTimeout(this.searchTimer);
            }
            this.searchTimer = setTimeout(() => {
                if (this.qs) {
                    ProductApi.searchPurchasedProducts(this.supplier.id, this.qs).then((r) => {
                        this.suggestions = r.data;
                    });
                }
            }, 600);
        },
        fetchResults(qs) {
            console.log('fetching', qs);
            if (this.searchTimer) {
                clearTimeout(this.searchTimer);
            }
            this.searchTimer = setTimeout(() => {
                ProductApi.searchPurchasedProducts(this.supplier.id, qs).then((r) => {
                    this.suggestions = [{data: r.data}];
                });
            }, 600);
        },
        onSuggestionSelect({item}) {
            this.$emit('input', item);
        },

        pick(product) {
            this.showSuggestion = false;
            this.$emit('input', product);
        },

        handleFocusOut() {
            this.showSuggestion = false;
        },

        getValue() {
            return this.qs;
        }
    },
    watch: {
        value(value) {
            if (this.qs !== value) {
                this.qs = value;
            }
        }
    }
}
</script>

<style scoped>

</style>
